import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => {
  return {
    subheader: {
      backgroundColor: theme.palette.common.lightBlue,
      padding: '12px 32px 24px',
    },
    online: {
      color: theme.palette.success.main,
    },
    reserved: {
      color: theme.palette.primary.main,
    },
    late: {
      color: theme.palette.error.main,
    },
    searchIcon: {
      color: theme.palette.text.primary,
      fontSize: theme.typography.pxToRem(16),
    },
    containerThin: {
      padding: '15px 30px 15px 15px',
    },
  };
});

const CardStyles = makeStyles({
  root: {
    padding: 0,
    paddingBottom: '0 !important',
  },
});

const tableStyles = {
  headRow: {
    style: {
      backgroundColor: '#F4F5F7',
      border: '0px 0px 1px 0px',
    },
  },
  rows: {
    style: {
      height: 'auto',
    },
  },
  pagination: {
    style: {
      border: '1px 0px 0px 0px',
    },
  },
};

export { useStyles, CardStyles, tableStyles };
